import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=a851e694&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=a851e694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a851e694",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a851e694')) {
      api.createRecord('a851e694', component.options)
    } else {
      api.reload('a851e694', component.options)
    }
    module.hot.accept("./Detail.vue?vue&type=template&id=a851e694&scoped=true&", function () {
      api.rerender('a851e694', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ecoupon/vsm-user-management/Detail.vue"
export default component.exports